import ComponentWrapper from "../../fragments/component-wrapper/ComponentWrapper";

export default function Credits({ block, index }) {
  if (!block) return null;

  const HeadingTag = index === 0 ? "h1" : "h2";

  const columnLength = Math.ceil(block.items.length / 2);
  const columns = Array.from({ length: 2 }, (_, i) =>
    block.items.slice(i * columnLength, (i + 1) * columnLength)
  );
  // console.log(menuColumns);

  return (
    <ComponentWrapper className="Credits">
      <div className={"l-grid"}>
        <div className="l-grid__col l-grid__col--m-3-12">
          {block.heading && (
            <HeadingTag className="h6 Credits-heading">
              {block.heading}
            </HeadingTag>
          )}
        </div>

        {columns.map((column, i) => (
          <div
            className="l-grid__col l-grid__col--m-4-12 Credits-column"
            key={i}
          >
            {column.map((item, j) => (
              <div className="Credits-item" key={j}>
                <p className="h8">{item.heading}</p>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        ))}
      </div>
    </ComponentWrapper>
  );
}
